module.exports = __webpack_public_path__ + "img/hauzenberg.26c1bb1.jpg";